import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconPercent } from '@sorare/core/src/atoms/icons/system/iconPercent.ts';
import { GqlFilterTitle } from '@sorare/core/src/contexts/graphql-search';
import type { Filter, FilterWidget } from '@sorare/core/src/lib/filters';
import { FILTERS } from '@sorare/core/src/lib/filters';

import {
  BackendRangeSlider,
  RangeSlider,
} from '#src/search/RangeSlider/index.tsx';
import { makeRangeFilter } from '#src/searchCards/RangeSlider/index.tsx';

type BoundedFilter = Filter & {
  urlAttribute: string;
  min: number;
  max: number;
};

const toPercent = (basisPoints: number) => (basisPoints / 100).toFixed(0);
const toBasisPoints = (percent: number) => percent * 100;

const percentIcon = <FontAwesomeIcon icon={iconPercent} />;

const makeBackendStartingPredictionFilter = (
  filter: BoundedFilter
): FilterWidget => ({
  key: filter.urlAttribute,
  type: 'range',
  attribute: filter.urlAttribute,
  title: <GqlFilterTitle name={filter.urlAttribute} title={filter.title} />,
  Component: ({ visible }) => (
    <BackendRangeSlider
      visible={visible}
      attribute={filter.urlAttribute}
      minForced={filter.min}
      maxForced={filter.max}
      toInput={toPercent}
      fromInput={toBasisPoints}
      icon={percentIcon}
    />
  ),
});

const makeStartingPredictionFilter = (filter: BoundedFilter): FilterWidget =>
  makeRangeFilter(
    ({ visible }) => (
      <RangeSlider
        visible={visible}
        attribute={filter.attribute}
        minForced={filter.min}
        maxForced={filter.max}
        toInput={toPercent}
        fromInput={toBasisPoints}
        icon={percentIcon}
      />
    ),
    filter
  );

export const RefineStartingPrediction = makeStartingPredictionFilter(
  FILTERS.startingPrediction
);

export const RefineBackendStartingPrediction =
  makeBackendStartingPredictionFilter(FILTERS.startingPrediction);

export const RefineBackendClassicStartingPrediction =
  makeBackendStartingPredictionFilter(FILTERS.startingPredictionClassic);
